import { render, staticRenderFns } from "./ModalEditPay.vue?vue&type=template&id=1dd54868&"
import script from "./ModalEditPay.vue?vue&type=script&lang=ts&"
export * from "./ModalEditPay.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditPay.vue?vue&type=style&index=0&id=1dd54868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports